<template>
    <div class="collect">
        <div class="collect_head">
            <ul>
                <li v-for="(item,index) in tabsCard.tabs" :class="index == tabsCard.num ? 'active' : ''" :key="index" @click="tab(index)">
                    <span>{{ item }}</span>
                </li>
            </ul>
            <span v-if="!isEdit" @click="changeEditStatus">编辑</span>
            <div v-else class="barSty">
                <span style="margin-right: 10px;" @click="cancelEdit(false)">取消</span>
                <span @click="cancelEdit(true)">删除</span>
            </div>
        </div>
        <div class="main">
            <!-- 电影 -->
            <div v-if="tabsCard.num == 0">
                <el-checkbox-group v-model="checkList">
                    <div class="itemCard" v-for="(item,index) in showData" :key='index'>
                        <div class="card">
                            <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="" @click="tvplay(item.videoInfo.id)">
                            <img src="../../../assets/images/mine/upload.png" style="width:18px;height:16px;position:absolute;right:10px;bottom:10px; z-index: 999" alt="" @click="tvplay(item.videoInfo.id)">
                            <div class="layer" v-show="isEdit">
                                <el-checkbox :label="item.id"></el-checkbox>
                            </div>
                            <div class="cardDes">
                                <p>{{ item.videoInfo.videoName}}</p>
                                <p v-if="item.episode">第{{item.episode}}集</p>
                            </div>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <!-- 电视剧 -->
            <div v-if="tabsCard.num == 1">
                <el-checkbox-group v-model="checkList">
                    <div class="itemCard" v-for="(item,index) in showData" :key='index'>
                        <div class="card">
                            <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="" @click="tvplay(item.videoInfo.id)">
                            <img src="../../../assets/images/mine/upload.png" style="width:18px;height:16px;position:absolute;right:10px;bottom:10px; z-index: 999" alt="" @click="tvplay(item.videoInfo.id)">
                            <div class="layer" v-show="isEdit">
                                <el-checkbox :label="item.id"></el-checkbox>
                            </div>
                            <div class="cardDes">
                                <p>{{ item.videoInfo.videoName}}</p>
                                <p v-if="item.episode">第{{item.episode}}集</p>
                            </div>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <!-- 娱乐生活 -->
            <div v-if="tabsCard.num == 2">
                <el-checkbox-group v-model="checkList">
                    <div class="itemCard" v-for="(item,index) in showData" :key='index'>
                        <div class="card">
                            <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="" @click="tvplay(item.videoInfo.id)">
                            <img src="../../../assets/images/mine/upload.png" style="width:18px;height:16px;position:absolute;right:10px;bottom:10px; z-index: 999" alt="" @click="tvplay(item.videoInfo.id)">
                            <div class="layer" v-show="isEdit">
                                <el-checkbox :label="item.id"></el-checkbox>
                            </div>
                            <div class="cardDes">
                                <p>{{ item.videoInfo.videoName}}</p>
                                <p v-if="item.episode">第{{item.episode}}集</p>
                            </div>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <!-- 全部 -->
            <div v-if="tabsCard.num == 3">
                <el-checkbox-group v-model="checkList">
                    <div class="itemCard" v-for="(item,index) in showData" :key='index'>
                        <div class="card">
                            <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="" @click="tvplay(item.videoInfo.id)">
                            <img src="../../../assets/images/mine/upload.png" style="width:18px;height:16px;position:absolute;right:10px;bottom:10px; z-index: 999" alt="" @click="tvplay(item.videoInfo.id)">
                            <div class="layer" v-show="isEdit">
                                <el-checkbox :label="item.id"></el-checkbox>
                            </div>
                            <div class="cardDes">
                                <p>{{ item.videoInfo.videoName}} 
                                <p v-if="item.episode">第{{item.episode}}集</p></p>
                            </div>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <div v-show="isShowNoContent" class="no-data">
                <img src="@/assets/images/no_data.png" alt="暂无下载记录">
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { getToken, setToken, setUser } from '../../../utils/auth.js'
    export default {
        data() {
            return {
                tabsCard: {
                    tabs: ['电影','电视剧','娱乐生活','全部'],
                    num: 0
                },
                checkList: [],
                isEdit: false,
                isShowNoContent: false,
                showData: [], // 主体展示数据
            }
        },
        methods: {
            tab(index) {
                this.tabsCard.num = index;
                let type;
                if(index == 0) {
                    type = 1;
                } else if(index == 1) {
                    type = 3;
                } else if(index == 2) {
                    type = 2;
                } else if(index == 3) {
                    type = '';
                }
                let obj = {
                    type,
                    fn: (res) => {
                        this.showData = res; 
                    }
                };
                this.downloadFn(obj); 
            },
            tvplay(cid) {
              this.$router.push({
                name: 'DownloadDetailPage',
                query: {
                  contentId: cid
                }
              })
            },
            download(cid) {
              this.$router.push({
                name: 'DownloadDetailPage',
                query: {
                  contentId: cid
                }
              })
            },
            changeEditStatus() {
                this.isEdit = true;
            },
            cancelEdit(status) {
                var timestamp = Date.parse(new Date())
                if(status) {
                    if (this.checkList.length === 0) {
                        return this.$message.warning('请选择要删除的数据')
                    }
                    this.$confirm('确定删除吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        // 选中删除的卡片
                        var str = this.checkList.join(',')
                        let headers = {
                            token : getToken()
                        }
                        let params = {
                            downloadIds: str
                        }
                        var checklist = this.checkList
                        axios({
                            method: 'DELETE',
                            headers: headers,
                            data: params,
                            url: '/realNet/download/delete?_=' + timestamp
                        }).then(res => {
                                var resObj = res.data
                                if (resObj.code === 200){
                                    this.$message.success('删除成功')
                                    this.isEdit = false
                                    this.checkList = []
                                    this.delList(checklist)
                                } else {
                                    console.log(res)
                                }
                                }).catch(function (e) {
                                    console.log(e)
                                })
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消删除'
                            })
                        })
                } else {
                    this.isEdit = false
                    this.checkList = []
                }
            },
            delList( arr) {
              var list = this.showData
              for (var i = list.length -1; i >= 0; i--){
                if (arr.indexOf(list[i].id) !== -1) {
                  list.splice(i, 1)
                }
              }
              if (list.length === 0){
                this.isShowNoContent = true
              }
              this.showData = list
            },
            //类别
            downloadFn(obj){
               let data = {
                    token: getToken()
                };
                let params = {
                    "videoInfo.categoryId": 4,
                    "videoInfo.shareCategoryIds": obj.type,
                    orderByType: 'DESC',
                    pageSize: 21
                    
                };
                var timestamp = Date.parse(new Date());
                axios({
                    method: 'get',
                    url: '/realNet/download/getDownloads?_='+timestamp,
                    headers: data,
                    params: params
                })
                .then((res) =>{
                  console.log(res)
                    if(res.data.result.content.length == 0) {
                        this.isShowNoContent = true;
                    } else {
                        this.isShowNoContent = false;
                    }
                    obj.fn(res.data.result.content);
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
         mounted() {
            let obj = {
                type: 1,
                fn: (res) => {
                   this.showData = res; 
                }
            };
           this.downloadFn(obj); 
        }
    }
</script>

<style lang='scss' scoped>
    .collect {
        width: 930px;
        .collect_head {
            width: 100%;
            height: 41px;
            border: 1px solid #EAECED;
            padding: 0 40px;
            margin-bottom: 30px;

            background-color: #F9F9F9;
            box-sizing: border-box;

            display: flex;
            justify-content: space-between;
            align-items: center;

            ul {
                width: 70%;
                height: 100%;
                padding: 0;

                li {
                    height: 100%;
                    padding: 0 20px;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                    float: left;
                    font-size: 14px;
                    position: relative;
                    
                    span {
                        cursor: pointer;
                    }
                }
                .active {
                    font-weight: bold;

                    &::before {
                        position: absolute;
                        left: 50%;
                        margin-left: -15px;
                        bottom: -2px;
                        content: '';
                        background-color: #3BC0D0;
                        width: 35px;
                        height: 3px;
                    }
                }
            }
                    
            & > span {
                font-size: 14px;
                color: #2CB5C5;
                cursor: pointer;
            }
            .barSty {
                font-size: 14px;
                color: #2CB5C5;
                cursor: pointer;
            }
            
        }
        .main {
            width: 100%;
            div {
                width: 100%;
                .itemCard {
                    width: 290px;
                    height: 190px;
                    margin: 0 18px 40px 0;
                    display: inline-block;
                    cursor: pointer;
                    .card {
                        width: 290px;
                        height: 165px;
                        margin-bottom: 10px;
                        background-color: #ccc;
                        position: relative;
                        span {
                            width: 84px;
                            height: 24px;
                            position: absolute;
                            right: 10px;
                            bottom: 10px;
                            font-size: 14px;
                            color: #fff;
                            background-color: rgba(#000,.65);
                            border-radius: 12px;
                            text-align: center;
                            line-height: 24px;
                        }
                        .layer {
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: 10;
                            width: 100%;
                            height: 100%;
                            background-color: rgba(#000,.3);
                        }
                        .cardDes {
                            display: flex;
                            justify-content: space-between;
                            p {
                                font-size: 16px;
                            }
                            p:first-child {
                                width: 216px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                    .card img{
                         width: 290px;
                        height: 165px;
                    }
                }
            }
        }
        .no-data {
            text-align: center;
        }
    }
</style>
